import { copyTextToClipboard } from "./copy-to-clipboard";

export const copyHTMLToClipboard = () => {
  let values: any = [];
  document.querySelectorAll('.text_to_copy').forEach((p) => values.push(p.textContent));
  copyTextToClipboard(values.join('\n '))
}
